<template>
  <div>
    <v-container grid-list-xl fluid>
      <table-payment-address coin="XPUB"></table-payment-address>
    </v-container>
  </div>
</template>

<script>
import TablePaymentAddress from "@/components/table/TablePaymentAddress";

export default {
  name: "PaymentBitcoinList",
  components: {
    TablePaymentAddress
  }
};
</script>

<style scoped></style>
